module.exports = __webpack_public_path__ + "media/images/tailwind/foot2-6dfaa922d59ccecdd12edc3648e6852f.png";